import * as types from './constants';

const initialState = {
    loading: false,
    data: null,
    error: null,
    updateSuccess: false
};

const versionReducer = (state = initialState, action) => {
    switch (action.type) {
        // GET VERSION
        case types.GET_VERSION_REQUEST:
            return { ...state, loading: true, error: null, updateSuccess: false };
        case types.GET_VERSION_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case types.GET_VERSION_FAILURE:
            return { ...state, loading: false, error: action.payload, data: null };

        // UPDATE VERSION
        case types.UPDATE_VERSION_REQUEST:
            return { ...state, loading: true, error: null, updateSuccess: false };
        case types.UPDATE_VERSION_SUCCESS:
            return { ...state, loading: false, data: action.payload, updateSuccess: true };
        case types.UPDATE_VERSION_FAILURE:
            return { ...state, loading: false, error: action.payload, updateSuccess: false };

        default:
            return state;
    }
};

export default versionReducer;